<template>
    <footer class="text-center mt-24 text-white">

          <h1 class="center text-xl font-valorant block"><span class="text-red-500">vALORaNT</span>ACCOUNTS</h1>    


    </footer>
</template>


<script>


export default {
  name: 'Footer',
  data () {
    return {

    }
  },
 beforeMount(){

 },    
}
</script>


// WEBPACK FOOTER //
// src/components/Footer.vue